<template>
    <div class="modal fade" tabindex="-1" role="dialog"
        v-bind:id="modalId"
        v-bind:aria-labelledby="modalId +'Label'"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="discardAddress">
                        <span aria-hidden="true"></span>
                    </button>
                    <h2 class="modal-title">Shipping Address</h2>
                </div>
                <div class="modal-body">
                    <p class="text-center">
                        <slot></slot>
                    </p>
                    <form class="info-form"><!-- info-space -->
                        <div class="row">
                            <div class="col-sm-5" v-bind:class="{'has-error': errors.has('address.first_name') }">
                                <input type="text" class="form-control" placeholder="First Name"
                                    v-model="address.first_name"
                                    data-vv-name="address.first_name"
                                    v-validate:address.first_name.initial="'required'"
                                />
                            </div>
                            <div class="col-sm-2">
                                <input type="text" class="form-control" placeholder="M.I." v-model="address.middle_name">
                            </div>
                            <div class="col-sm-5" v-bind:class="{'has-error': errors.has('address.last_name') }">
                                <input type="text" class="form-control" placeholder="Last Name"
                                    v-model="address.last_name"
                                    data-vv-name="address.last_name"
                                    v-validate:address.last_name.initial="'required'"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <input type="text" class="form-control" placeholder="Company" v-model="address.company">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" v-bind:class="{'has-error': errors.has('address.country') }">
                                <country-selector class="form-control"
                                    v-on:country-change="onCountryChange"
                                    v-bind:countries="countries"
                                    v-bind:country="address.country"
                                    v-on:change="onFedexFieldBlur('country')"
                                    v-bind:class="{'validated': fedex.isValidated}"
                                    data-vv-name="address.country"
                                    data-vv-value-path="selectedCountry"
                                    v-validate:address.country.initial="'required'"
                                ></country-selector>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12" v-bind:class="{'has-error': errors.has('address.address1') }">
                                <input type="text" class="form-control" placeholder="Address 1"
                                    v-model="address.address1"
                                    v-on:blur="onFedexFieldBlur('address1')"
                                    v-bind:class="{'validated': fedex.isValidated}"
                                    data-vv-name="address.address1"
                                    v-validate:address.address1.initial="'required'"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-12">
                                <input type="text" class="form-control" placeholder="Address 2" v-model="address.address2">
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-sm-4" v-bind:class="{'has-error': errors.has('address.city') }">
                                <input type="text" class="form-control" placeholder="City"
                                    v-model="address.city"
                                    v-on:blur="onFedexFieldBlur('city')"
                                    v-bind:class="{'validated': fedex.isValidated}"
                                    data-vv-name="address.city"
                                    v-validate:address.city.initial="'required'"
                                />
                            </div>
                            <div class="col-sm-4">
                                <state-province-selector class="form-control"
                                    ref="vmStateProvinceSelector"
                                    v-on:state-change="onStateChange"
                                    v-bind:country="address.country"
                                    v-bind:states="regions"
                                    v-bind:state="address.state_prov"
                                    v-on:change="onFedexFieldBlur('state_prov')"
                                    v-bind:class="{'validated': fedex.isValidated}"
                                ></state-province-selector>
                            </div>
                            <div class="col-sm-4" v-bind:class="{'has-error': errors.has('address.postal_code') }">
                                <input type="text" class="form-control" placeholder="Postal Code"
                                    v-model="address.postal_code"
                                    v-on:blur="onFedexFieldBlur('postal_code')"
                                    v-bind:class="{'validated': fedex.isValidated}"
                                    data-vv-name="address.postal_code"
                                    data-vv-delay="100"
                                    v-validate:address.postal_code.initial="'required|min:5'"
                                />
                            </div>
                        </div>
                        <div class="wrap text-danger" v-if="!fedex.isValidated && fedex.errorMessage.length > 0">
                            <span>{{ fedex.errorMessage }}</span>
                        </div>
                        <div class="btn-wrap text-right">
                            <button class="btn btn-danger"
                                v-bind:disabled="isAddressUnresolved"
                                v-on:click="submitAddress"
                            >Save</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script type="text/jsx">
    import { Event } from '../../../../../assets/js/components/frontend/event.vue'
    import CountrySelector from '../elements/country-selector.vue'
    import StateProvinceSelector from '../elements/state-province-selector.vue'

    import Vue from 'vue';
    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    export default {
        name: 'address-popup',
        mixins: [
            require('../mixin/fedex-validation.vue')
        ],
        components: {
            'country-selector': CountrySelector,
            'state-province-selector': StateProvinceSelector
        },
        data: function () {
            return this.getDefaultAddressData();
        },
        props: {
            modalId: {
                type: String,
                required: true,
                default: function () {
                    return 'vueAddressModal'
                }
            },
            countries: {
                type: Object,
                required: true
            },
            regions: {
                type: Object,
                required: true
            },
            defaultCountry: {
                type: String,
                required: false,
                default: function () {
                    return 'US';
                }
            },
            onFedexResult: {
                type: String,
                default: function () {
                    return 'addressPopupHandleFedexResult';
                }
            },
            invokedOn: {
                type: String,
                required: true,
                default: function () {
                    return 'showAddressPopupModal';
                }
            },
            onDiscard: {
                type: String,
                required: true,
                default: function () {
                    return 'onAddressPopupDiscard';
                }
            },
            onSubmit: {
                type: String,
                required: true,
                default: function () {
                    return 'onAddressPopupSubmit';
                }
            }
        },
        created: function () {
            Event.$on(this.invokedOn, this.onAddressPopupInvokeModal);
        },
        beforeDestroy: function () {
            Event.$off(this.invokedOn, this.onAddressPopupInvokeModal);
        },
        methods: {
            getDefaultAddressData: function () {
                return {
                    onSubmitEvent: this.onSubmit,
                    onDiscardEvent: this.onDiscard,
                    states: this.regions[this.defaultCountry] || {},
                    address: {
                        /**/
                        first_name: '',
                        middle_name: '',
                        last_name: '',
                        company: '',
                        address1: '',
                        address2: '',
                        city: '',
                        state_prov: '',
                        postal_code: '',
                        country: this.defaultCountry
                        /**/
                        // DEBUG
                        /** /
                         first_name: 'Lorain',
                         middle_name: 'M.',
                         last_name: 'Ipson',
                         company: 'TST',
                         address1: '111 main st',
                         address2: 'apt 22',
                         city: 'Nashville',
                         state_prov: 'TN',
                         postal_code: '37000',
                         country: this.defaultCountry
                         /**/
                    },
                    fedex: {
                        event: 'validateAddress',
                        listener: this.onFedexResult, // overridden
                        container: 'address',
                        isValidated: false,
                        errorMessage: ''
                    }
                }
            },
            onAddressPopupInvokeModal: function (data) {
                this.reset();
                for (var key in data) {
                    this.$data[key] = data[key];
                }
                $('#' + this.modalId).modal('show');
            },
            reset: function () {
                Object.assign(this.$data, this.getDefaultAddressData());
                /**/ this.$refs.vmStateProvinceSelector.reset();
                this.errors.clear();
            },
            submitAddress: function () {
                this.$validator.validateAll().then(() => {
                    var addr = Object.assign({}, this.address);
                    Event.$emit(this.onSubmitEvent, addr);
                    $('#' + this.modalId).modal('hide');
                    this.reset();
                }).catch(function (e) {
                    console.log('ADDRESS POPUP: Need to correct some errors first!', e);
                });
            },
            discardAddress: function () {
                $('#' + this.modalId).modal('hide');
                Event.$emit(this.onDiscardEvent);
                this.reset();
            },
            onCountryChange: function (countryCode) {
                if (countryCode in this.regions) {
                    this.states = this.regions[countryCode];
                } else {
                    this.states = {};
                }
                this.address = Object.assign(this.address, { country: countryCode, state_prov: '' });
            },
            onStateChange: function (state) {
                this.address = Object.assign(this.address, { state_prov: state });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// address-popup.vue?793b1632